import React from 'react';
import { Text } from '@innovyze/stylovyze/lib/components';
import { StyledArrowBack, StyledBackLink } from './BackLink.styles';
export const BackLink = ({ label, onClick }) => {
    return (React.createElement(StyledBackLink, { onClick: onClick, "data-cy": "page-back-button" },
        React.createElement(StyledArrowBack, null),
        React.createElement(Text, { color: "secondary", variant: "caption-medium", dataCy: "page-back-text" }, label)));
};
